import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../clients/client';
import { CreateCategoryRequest } from '../requests/create.category.request';
import { State } from '../redux/redux.state';
import { EasysizeCategory } from '../models/easysize.category';
import { Status } from '../redux/redux.status';

const createCategoryUrl = 'category/create-category';
const getEasysizeCategoryUrl = 'category/get-easysize-categories';

type CategoryState = State<EasysizeCategory[]> & {
  createCategoryStatus: Status;
};

const initialState: CategoryState = {
  data: [],
  status: 'idle',
  createCategoryStatus: 'idle',
};

export const createProductCategory = createAsyncThunk(
  'createProductCategory',
  async (request: CreateCategoryRequest, { rejectWithValue }) => {
    try {
      const { shopId, categoryName, categoryGroup, easysizeCategory } = request;
      const { data } = await client.post(`${createCategoryUrl}/${shopId}`, {
        categoryName,
        easysizeCategory,
        categoryGroup,
      });
      return data;
    } catch (err: any) {
      const { status, data } = err.response;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

export const getEasysizeCategories = createAsyncThunk(
  'getEasysizeCategories',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await client.get(getEasysizeCategoryUrl);
      return data;
    } catch (err: any) {
      const { status, data } = err.response;
      return rejectWithValue({ status, errorMessage: data });
    }
  }
);

const categorySlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    resetCategoryData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEasysizeCategories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getEasysizeCategories.fulfilled, (state, action) => {
        state.data = action.payload.easysize_categories;
        state.status = 'successful';
      })
      .addCase(getEasysizeCategories.rejected, (state, action) => {
        state.errors = action.payload;
        state.status = 'error';
      })
      .addCase(createProductCategory.pending, (state) => {
        state.createCategoryStatus = 'loading';
      })
      .addCase(createProductCategory.fulfilled, (state) => {
        state.createCategoryStatus = 'successful';
      })
      .addCase(createProductCategory.rejected, (state) => {
        state.createCategoryStatus = 'error';
      });
  },
});

export default categorySlice.reducer;

export const { resetCategoryData } = categorySlice.actions;
